import styled from 'styled-components';

export const MainMenuContainer = styled.div`
  width: 260px;
`;
